import {Badge, Typography} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';

import * as styles from './answer-mention-badge.scss';

type PropsType = {
    brandMentioned: boolean | null;
};

// Whether the brand showed up in the answer at all — the primary verdict of a row.
export function AnswerMentionBadge(props: PropsType): JSX.Element {
    const {brandMentioned} = props;

    return (
        <Badge
            status={brandMentioned ? 'success' : 'default'}
            text={
                <Typography.Text className={styles.answer_mention_badge__text} strong>
                    <Locale
                        stringKey={
                            brandMentioned
                                ? 'AI_BRAND_MONITORING__ANSWERS__MENTIONED'
                                : 'AI_BRAND_MONITORING__ANSWERS__NOT_MENTIONED'
                        }
                    />
                </Typography.Text>
            }
        />
    );
}
